import { Label } from "reactstrap";
import React, { useState } from "react";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import parse from "autosuggest-highlight/parse";
import { debounce } from "@mui/material/utils";

import { GoogleApiKey } from "../../../../common/googleApiKey";
import { useLoadScript } from "@react-google-maps/api";

import LoadingSpinner from "../../../Common/Spinner";
import { isEmpty } from "lodash";
import { CustomSelect } from "../../../Common/CustomSelect";
import AppModal from "../../../Common/AppModal";
const googleMapsApiKey = GoogleApiKey;
const libraries = ["places"];

const SearchAddress = ({ taskData, setTaskData }) => {
  const [addNewLocationModal, setAddNewLocationModal] = useState(false);
  const toggleAddNewLocationModal = () =>
    setAddNewLocationModal(!addNewLocationModal);

  const {
    ready,
    value,
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete();
  console.log("data", data);
  const handleSelect = async (val) => {
    setValue(val, false);
    clearSuggestions();
    try {
      const results = await getGeocode({ address: val?.description });
      const result = await getLatLng(results[0]);
      console.log("results", results);
      console.log("result", result);
      // save location data
      setTaskData({
        ...taskData,
        LocationLatitude: result.lat,
        LocationLongitude: result.lng,
      });
    } catch (error) {
      console.log("error");
    }
  };
  console.log("taskData", taskData);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey,
    libraries,
  });

  return (
    <>
      <AppModal
        open={addNewLocationModal}
        onClose={toggleAddNewLocationModal}
        title={
          !taskData?.LocationLatitude &&
          !taskData?.LocationLongitude &&
          !taskData?.LocationAddressPostcode
            ? "Add New Location"
            : "Edit Location"
        }
        icon={<LocationOnOutlinedIcon />}
        headerAccent="indigo"
        size="md"
        hideFooter
      >
          {isLoaded ? (
            <div>
              <div>
                <h5>Search Address Coordinates</h5>
                {/*  TODO Rebuild selection*/}
                {/*<Combobox onSelect={handleSelect}>*/}
                {/*  <ComboboxInput*/}
                {/*    className="google-maps-combobox-input "*/}
                {/*    value={value}*/}
                {/*    onChange={(e) => setValue(e.target.value)}*/}
                {/*    disabled={!ready}*/}
                {/*    placeholder="Enter an address"*/}
                {/*  />{" "}*/}
                {/*  <ComboboxPopover style={{ zIndex: "9999" }}>*/}
                {/*    <ComboboxList style={{ zIndex: "9999" }}>*/}
                {/*      {status === "OK" &&*/}
                {/*        data?.map(({ place_id, description }) => (*/}
                {/*          <ComboboxOption*/}
                {/*            style={{ zIndex: "9999" }}*/}
                {/*            key={place_id}*/}
                {/*            value={description}*/}
                {/*          />*/}
                {/*        ))}*/}
                {/*    </ComboboxList>*/}
                {/*  </ComboboxPopover>*/}
                {/*</Combobox>*/}
                {/*    Rewrite with new material UI components*/}
                <Autocomplete
                  id="google-map-demo"
                  sx={{ width: "100%" }}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.description
                  }
                  filterOptions={(x) => x}
                  options={status === "OK" && data ? data : []}
                  autoComplete
                  includeInputInList
                  filterSelectedOptions
                  value={value}
                  noOptionsText="No locations"
                  onChange={(event, newValue) => {
                    handleSelect(newValue);
                  }}
                  onInputChange={(event, newInputValue) => {
                    setValue(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Add a location" fullWidth />
                  )}
                  renderOption={(props, option) => {
                    const matches =
                      option.structured_formatting
                        .main_text_matched_substrings || [];

                    const parts = parse(
                      option.structured_formatting.main_text,
                      matches.map((match) => [
                        match.offset,
                        match.offset + match.length,
                      ])
                    );

                    console.log("option", option);
                    return (
                      <li {...props}>
                        <Grid container alignItems="center">
                          <Grid item sx={{ display: "flex", width: 44 }}>
                            <LocationOnIcon sx={{ color: "text.secondary" }} />
                          </Grid>
                          <Grid
                            item
                            sx={{
                              width: "calc(100% - 44px)",
                              wordWrap: "break-word",
                            }}
                          >
                            {parts.map((part, index) => (
                              <Box
                                key={index}
                                component="span"
                                sx={{
                                  fontWeight: part.highlight
                                    ? "bold"
                                    : "regular",
                                }}
                              >
                                {part.text}
                              </Box>
                            ))}
                            <Typography variant="body2" color="text.secondary">
                              {option.structured_formatting.secondary_text}
                            </Typography>
                          </Grid>
                        </Grid>
                      </li>
                    );
                  }}
                />
              </div>
            </div>
          ) : (
            <LoadingSpinner />
          )}
          <div>
            <div className={"mt-2"}>
              <div>
                <Label>Latitude</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationLatitude}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationLatitude: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Longitude</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationLongitude}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationLongitude: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Address Line 1</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressLine1}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressLine1: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Address Line 2</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressLine2}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressLine2: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Address Line 3</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressLine3}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressLine3: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Address Line 4</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressLine4}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressLine4: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>City</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressCity}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressCity: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>County</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressCounty}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressCounty: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Postcode</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressPostcode}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressPostcode: e.target.value,
                    })
                  }
                />
              </div>
              <div className={"mt-2"}>
                <Label>Country</Label>
                <input
                  className={"form-control"}
                  type="text"
                  value={taskData?.LocationAddressCountry}
                  onChange={(e) =>
                    setTaskData({
                      ...taskData,
                      LocationAddressCountry: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div>
              <button
                onClick={toggleAddNewLocationModal}
                className={"btn btn-success mt-4 w-100"}
              >
                Save
              </button>
            </div>
          </div>
      </AppModal>
      <div>
        {" "}
        <div>
          <Label>Location</Label>
        </div>
        <div>
          {taskData?.LocationLatitude && (
            <span className={"me-1"}>Lat: {taskData?.LocationLatitude} </span>
          )}
          {taskData?.LocationLongitude && (
            <span className={"me-1"}>
              Long: {taskData?.LocationLongitude},{" "}
            </span>
          )}
          {taskData?.LocationAddressLine1 && (
            <span className={"me-1"}>Address:</span>
          )}
          {taskData?.LocationAddressLine1 && (
            <span className={"me-1"}>{taskData?.LocationAddressLine1} </span>
          )}
          {taskData?.LocationAddressLine2 && (
            <span className={"me-1"}>{taskData?.LocationAddressLine2} </span>
          )}{" "}
          {taskData?.LocationAddressLine3 && (
            <span className={"me-1"}>{taskData?.LocationAddressLine3} </span>
          )}{" "}
          {taskData?.LocationAddressLine4 && (
            <span className={"me-1"}>{taskData?.LocationAddressLine4} </span>
          )}
          {taskData?.LocationAddressCity && (
            <span className={"me-1"}>{taskData?.LocationAddressCity} </span>
          )}
          {taskData?.LocationAddressCounty && (
            <span className={"me-1"}>{taskData?.LocationAddressCounty} </span>
          )}
          {taskData?.LocationAddressPostcode && (
            <span className={"me-1"}>{taskData?.LocationAddressPostcode} </span>
          )}
          {taskData?.LocationAddressCountry && (
            <span className={"me-1"}>
              Postcode: {taskData?.LocationAddressCountry}{" "}
            </span>
          )}
        </div>
        <div className={"mt-2"}>
          <button
            onClick={toggleAddNewLocationModal}
            className={
              (!taskData?.LocationLatitude &&
              !taskData?.LocationLongitude &&
              !taskData?.LocationAddressPostcode
                ? "btn-success"
                : "btn-warning") + " btn"
            }
          >
            {!taskData?.LocationLatitude &&
            !taskData?.LocationLongitude &&
            !taskData?.LocationAddressPostcode
              ? "Add New Location"
              : "Edit Location"}
          </button>
        </div>
      </div>
    </>
  );
};

export default SearchAddress;
